<div class="card">
  <div class="card-body">
    <h5 class="card-title text-alert">Password Changed Alert</h5>
    <p class="card-text text-info">Your password has been successfully updated.</p>
    <a (click)="navigateUser()" class="btn btn-primary">Go Back to Signin</a>
  </div>
</div>
